import React from "react";
import { Link } from "react-router-dom";

import "../path/Path.css";

export default function InsightCategoryPath(props) {
  const { category } = props;
  const { categoryID } = props;

  return (
    <div className="insight-path">
      <Link to="/portfolio" className="path-link">
        {"Portfolio"}
      </Link>
      <div className="path-divider">{" > "}</div>
      <Link to={"/insights"} className="path-link">
        {"Insights"}
      </Link>
      <div className="path-divider">{" > "}</div>
      <Link to={`/insights/categories`} className="path-link">
        {"Categories"}
      </Link>
      <div className="path-divider">{" > "}</div>
      <Link
        to={`/insights/category/${categoryID}/articles`}
        className="path-link-current"
      >
        {category}
      </Link>
    </div>
  );
}
